module.exports = __webpack_public_path__ + "media/configurations/P-X-SX-SX-X-P-d6fe093d.png";